var exports = {
  "p": "x234b8571--46aa08--info",
  "M": "x234b8571--46aa08--info__group",
};

module.exports = exports;
